module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm09_int"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("Introduction"), _c('br'), _c('em', [_vm._v("Marriage Promotion, Heterosexuality, and “Being American”")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("What can be done to nourish the cultural ideal that must be restored if we are to revive the nuclear family: voluntary lifelong monogamy? [We must] spread the word about the emotional, economic, and health benefits of lifelong monogamy, and about how it is superior to other family forms, and continue to privilege marriage through public policy.")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—David Popenoe, “Can the Nuclear Family Be Revived?”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en1a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("We in the United States are currently in the midst of what might be called a marriage moment—a time of unusual, perhaps unprecedented, national preoccupation with the status and future of marriage. One reason for this is the growing public and scholarly concern over the weakness of the institution. . . . A second reason, closely connected to the first, is the emergence of the marriage movement. A third reason, currently dominant, is the controversy over same-sex marriage, which erupted in full force in the United States in mid 2003, making the marriage debate much hotter and more political.")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—David Blankenhorn, "), _c('em', [_vm._v("The Future of Marriage")]), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en2a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It was a sunny but chilly February day in Oklahoma City as I gathered at the state capitol with approximately four hundred people to rally for an issue that David Blankenhorn—the founder and president of the Institute for American Values, a pro-marriage organization—has characterized as a “national preoccupation.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en3a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" The Protect Marriage and the Traditional Family rally drew a mostly white crowd, along with approximately forty-five elected local, state, and federal officials, radio personalities, and religious leaders. Adults and children held handmade signs with phrases like, “Kids need both a mom "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("and a dad”; “God made us male and female because he loves us”; and “The sacred union between a man and a woman, where would you be without it?” The surge of activism in Oklahoma against same-sex marriage in 2004 represented only a segment of efforts to deal with “the status and future of marriage.” Starting in 1999, Oklahoma became one of the first states at the vanguard of national marriage promotion policies when it instituted an initiative financed with $10 million of its welfare grant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the United States, a self-identified marriage movement emerged in the late 1990s, uniting a coalition of clergy and religious leaders, family practitioners, welfare officials and employees, politicians, think-tank personnel, and other community activists to promote a “renaissance” for heterosexual marriage to stem its relentless decline."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en4a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Officially set in motion in 2000 with the release of “The Marriage Movement: A Statement of Principles,” its 113 signatories include prominent family scholars and researchers, such as William Doherty, Jean Bethke Elshtain, Amitai Etzioni, William Galston, Norval Glenn, Steven L. Nock, David Popenoe, Linda J. Waite, Judith Wallerstein, Barbara Dafoe Whitehead, and James Q. Wilson. The movement has combined grassroots efforts with broader goals to expand the role of government in promoting marriage at the state and national level."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en5a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Diane Sollee, a family therapist, founded the Coalition for Marriage, Family, and Couples Education (CMFCE) in 1996, a clearinghouse for the movement that sponsors the annual Smart Marriages conference to bring together those interested in rebuilding a marriage culture."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en6a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" While “marriage education” is a spinoff of the secular family-therapy movement of the 1970s, a strong component also involves faith-based programs like Marriage Savers, a ministry that works with local congregations to promote Community Marriage Policies and Covenants, which require engaged couples to complete four months of premarital counseling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nationally, the movement’s growth has been closely tied to state and federal funding of statewide and community marriage initiatives. The Personal Responsibility and Work Opportunity Reconciliation Act (PRWORA), the law signed by former President Clinton in 1996 to end over sixty years of federal welfare benefits to poor families, specifically designated marriage promotion in addition to job preparation and work as a sanctioned use of Temporary Assistance to Needy Families (TANF). In 1999, Oklahoma became the first state to set aside a significant amount of its TANF block grant money to promote marriage, establishing a precedent for other states to follow. Overall, Oklahoma has a punitive welfare system that ranks it among the lowest states in the amount of cash assistance offered to the poor. The fervent "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("antiwelfare stance of many policymakers and politicians, as well as the state’s religious conservatism, helped to create a receptive environment for the philosophy of marriage promotion, and specifically for the idea of a “marriage cure” for poverty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Following this initial activity, funding for marriage promotion began to increase substantially by 2002 when the Bush administration launched its Healthy Marriage Initiative within the U.S. Department of Health and Human Services, Administration for Children and Families (HHS/ACF), funding demonstration projects nationwide to disseminate a public message on the value of marriage. It diverted over $100 million from existing programs, including $6.1 million from the Child Support Enforcement Program, $9 million from the Refugee Resettlement Program, $14 million from the Child Welfare Program, and $40 million from the Social and Economic Development Strategies Program focusing on Native Americans."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en7a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" By 2004 every state in the union had undertaken at least one activity or made at least one policy change designed to promote marriage."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en8a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Bush signed into law the Deficit Reduction Act in 2005, which reauthorized welfare reform and sanctioned an appropriation of up to $150 million more per year from 2006 to 2010 to promote healthy marriages and responsible fatherhood."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en9a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Recently, President Obama proposed spending $500 million in his 2011 budget on a new Fatherhood, Marriage, and Family Innovation Fund, and Congress ultimately approved $75 million for marriage promotion activities and $75 million for funding responsible fatherhood initiatives for the current fiscal year. At the state level, three states—Ohio, Utah, and Texas—have followed Oklahoma’s lead to dedicate a portion of their TANF funds to create statewide initiatives (Texas allocated $16 million for fiscal year 2008–2009), and ten other states have also committed substantial amounts."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en10a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" These policies and programs have thus gained a substantial foothold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the marriage movement has turned to federal and local government agencies to promote marriage, conservative politicians, religious leaders, and other activists likewise seek federal and state legislation to “protect” it. Dating back to the 1970s but gaining momentum in the 1990s, the fight for same-sex marriage became a central organizing principle for lesbians and gay men as a result of the vociferous backlash of the “religious right”—a movement of conservative religious (and predominantly Christian) organizations that advocate social and political conservatism—to the possible legalization of same-sex marriage in Hawaii."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en11a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" The case of Hawaii spurred the passage of the federal Defense of Marriage Act (DOMA) in 1996, which provided the first federal definitions of “marriage” and “spouse” as one man and one "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("woman, and it ensured that no state is compelled to recognize the same-sex marriage contract of another state. Most individual states have passed their own DOMAs and some passed “super-DOMAs,” laws that block recognition not only of same-sex marriage but also of civil unions and domestic partnerships. In 2003, public controversy over same-sex marriage followed the decision by the Massachusetts Supreme Judicial Court in "), _c('em', [_vm._v("Goodridge v. Department of Public Health")]), _vm._v(" that established a right to marry for same-sex couples in the state’s constitution. Currently, marriage licenses to same-sex couples are granted by six states: Connecticut, Iowa, Massachusetts, New Hampshire, New York, Vermont, and in Washington, D.C. At both the state and national level, opponents have sought to pass constitutional amendments to ban legal same-sex marriage. Former president George W. Bush endorsed a Federal Marriage Amendment that would have amended the U.S. Constitution to define marriage as the union of one man and one woman, and the amendment would have prohibited states from legalizing same-sex marriage. Although the federal amendment failed, states continued to pass their own amendments. The battle is now being played out in California where the passage of Proposition 8 in 2008 made it the twenty-sixth state to approve such a measure. After a federal court ruled the amendment to be unconstitutional discrimination in 2010, the appeal case is expected to make its way to the U.S. Supreme Court.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The politics of marriage in the United States draws attention to the uncertainty Americans feel over major shifts in sexual morality, values, and family life in postindustrial societies. Moving with unparalleled momentum in the past few decades, such transformations have cast doubt on the future of marriage. The historian Stephanie Coontz contends that anxiety over a crisis in marriage is nothing new. Over time, many have heralded a crisis of the family."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en12a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" What is new, according to Coontz, is the speed in which the forms and values of marriage have changed since the late eighteenth century to idealize love as "), _c('em', [_vm._v("the")]), _vm._v(" fundamental reason to marry. From its inception, this “revolutionary new marriage system” contained the seeds of instability that have led to the current waning significance of the institution of marriage."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en13a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" While family transformations occur on a global scale—especially in Euro-American societies—America appears unique in its pervasive national preoccupation with what marriage advocates refer to as the “m-word.” Not only has the United States witnessed a burgeoning marriage movement, it has exported elements of it to other countries such as England, Australia, New Zealand, and Norway."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en14a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Likewise, the intensity of the acrimony over same-sex marriage in the United States distinguishes it from other countries, such as in the "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("case of Spain and Canada where both countries legalized same-sex marriage in 2005 with relatively minor upheaval. Why has marriage in the United States become an issue of pervasive national preoccupation and anxiety?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This question has motivated my research on the politics of marriage. To think about the organization of these politics, I examine marriage as an ideology that draws together national cultural repertoires of the middle-class, married, heterosexual family as "), _c('em', [_vm._v("the")]), _vm._v(" model of American citizenship. Ideologies organize group attitudes and knowledge to facilitate specific courses of action as appropriate and deviations as nonnormative and misguided. It is through cultural repertoires as systems of ideas, values, and strategies that individuals make sense of the social conditions they confront."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en15a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Relying on an ideology of marriage, advocates claim that revitalizing the institution is key to solving a vast array of America’s social problems, including crime, poverty, teen pregnancy, educational failure, and welfare “dependency.” In what might be described as a feedback loop, these cultural repertoires complement social policies and institutional practices that sustain inequalities based on gender, supporting beliefs on the essential role of male breadwinners and fathers; on race, reinforcing an ideology of the American dream and bourgeois normality to assimilate racial others; on class, through institutional policies that perpetuate poverty, especially for poor women of color; and on sexuality, buttressing the importance of the heteronormative family model. Thus, marriage ideology and politics both rely on "), _c('em', [_vm._v("and")]), _vm._v(" contribute to inequality, often in unexpected ways.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the pages that follow, I uncover the social consequences of efforts to reinstitutionalize a concept of “one marriage” in the United States through government, legal, and cultural intervention. The historian John Gillis has astutely remarked, “We all have two families, one that we live "), _c('em', [_vm._v("with")]), _vm._v(" and another we live "), _c('em', [_vm._v("by")]), _vm._v(".”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en16a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" This book examines symbolic contests over marriage—over the “one marriage” we live by—to illuminate what is the case for the families we live with. To study these politics, I conducted ethnographic research in Oklahoma, viewing its policies as both “extending out” and being influenced by national marriage promotion politics."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en17a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" I examine the ways that ideologies to reinforce a boundary of heterosexual marriage lead to uneven and contradictory consequences on the ground.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("The Politics of Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Contemporary political battles over marriage and family in the United States grew in the late 1970s, a time when the divorce rate peaked and a national White House Conference on The Family, planned under the Carter administration, "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("splintered into three polarized regional conferences during the Reagan administration."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en18a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" While liberalizing trends in cultural understandings and practices of sexuality began long before the 1960s, transformations in family and sexual mores accelerated during this decade due to social and economic developments. Over a twenty-year period, the divorce rate more than doubled from the mid-1960s, leveling off somewhat to the point where almost half of all marriages are estimated to dissolve."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en19a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" In the early 1980s, one out of six births occurred outside marriage, a much higher ratio than two decades earlier."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en20a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" By the twenty-first century, this figure had grown to one out of three."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en21a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Similar and higher figures are found in Canada, the United Kingdom, Ireland, and Nordic countries."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en22a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Today, roughly one in twenty U.S. couples are cohabitating and most marriages begin after cohabitation."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en23a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Nearly a quarter of families are headed by single parents."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en24a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the United States, a renewed focus on the family resulted from the growth of the women’s movement, debates over a “culture of poverty” among African American families, and the rise of the religious right. The women’s liberation movement characterized the nuclear family as an axis of patriarchal power, rallying for the end of gender discrimination in the workplace and at home."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en25a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Controversy over the family also grew alongside the rise of unwed motherhood in the 1960s. Aid to Dependent Children (ADC) was renamed Aid to Families of Dependent Children (AFDC) in 1962 and was specifically designed to enhance the family wage system to help poor single mothers raise their children at home, replacing the breadwinning father with the paternal state. A series of legal victories eradicated the restrictive policies that barred many poor women, and particularly poor women of color, from receiving benefits. These factors partly contributed to welfare’s most dramatic growth since its inception: the number of families it served nearly tripled from 787,000 to 2,208,000 between 1960 and 1970."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en26a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" During this period, public concern began to grow over the increase in female-headed households that many pointed to as proof of the dysfunctional nature of black families. Daniel Patrick Moynihan’s 1965 report added fuel to the fire with his depiction of black single-mother families as a “tangle of pathology.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en27a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Finally, the 1970s witnessed the emergence of antifeminist, anti-abortion, and antigay evangelical movements, which merged together under the umbrella of the Moral Majority to advance “family values” and the state’s role in promoting marriage and family life."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en28a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" The Moral Majority laid the groundwork for the focus on the family during the Reagan-Bush years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the Republicans’ defeat of 1992 with Bill Clinton’s election, there was reason to believe that the predominance of family-values ideology would "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("subside. Instead, in the 1990s, Judith Stacey describes the rise of a “neo-family-values campaign” that embraced “an explicitly centrist politics, rhetoric, and ideology,” grounded its claims “in secular social science instead of religious authority,” and rejected “anti-feminism for a post-feminist ethic.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en29a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" By the turn of the century, this campaign had mobilized into the self-identified marriage movement, uniting a network of scholarly and policy institutes, including the Institute for American Values, with David Blankenhorn (the author of "), _c('em', [_vm._v("Fatherless America")]), _vm._v(")"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en30a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" as president, and the National Marriage Project, a research and public education initiative once based at Rutgers and originally codirected by David Popenoe, who is a professor of sociology at Rutgers, and Barbara Dafoe Whitehead, who is a journalist. The project has been housed since 2009 at the University of Virginia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Judith Stacey details the important role that social scientists played in shaping the field of marriage promotion and its knowledge claims."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en31a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Elsewhere, I have described these configurations of knowledge in terms of an “epistemic culture,” a domain constructed by the practices of experts that make up how we know what we know."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en32a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" I argue that examining the “machineries” of knowledge production sheds light on the practices involved in public policy formation within knowledge societies."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en33a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" In solidifying expert knowledges for their cause, leaders within movements like marriage promotion explicitly politicize scientific knowledge as a way to garner support from governments and policymakers for social change. In the case of marriage promotion, elite players at academic institutions lead and participate in this politicization.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Policy institutes and think tanks that embrace marriage promotion deploy social scientific knowledge to argue in favor of the universal benefits of marriage. In a 2002 document, the Institute for American Values spells out “Why Marriage Matters: Twenty-Six Conclusions from the Social Sciences.” A sampling includes, “Marriage is a virtually universal human institution; Marriage has important biosocial consequences for adults and children; Marriage reduces poverty and material hardship for disadvantaged women and their children.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en34a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" Statements such as these present knowledge about marriage without contextualization of scholarly debates and complexities. For example, historians, anthropologists, and sociologists have called into question marriage’s universality."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en35a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Likewise, there is debate about whether "), _c('em', [_vm._v("marriage")]), _vm._v(" itself can reduce poverty."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en36a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Arguments made by marriage advocates simplify the facts and suggest unanimity among social scientists. A fact sheet from the Institute for American Values explicitly espouses the “scholarly consensus on marriage”: “Marriage is an important social good, associated with an impressively broad array of positive outcomes for children and adults alike. Marriage is an important "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("public good, associated with a range of economic, health, educational, and safety benefits that help local, state, and federal governments serve the common good.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en37a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Dissemination of these facts is meant to influence public opinion concerning the importance of marriage: “That current rates of divorce, family conflict, and unwed childbearing are not good for children, for adults, or for society.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en38a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Marriage advocates seek to solidify the “case for marriage” because “married people are happier, healthier, and better off financially.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en39a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Supporters of the religious right and other conservative organizations have worked together to also promote marriage’s benefits. The sociologist Scott Coltrane traces the growth of marriage and fatherhood policies to think tanks funded with millions of dollars from conservative foundations, underscoring the connections between hybrid political-religious organizations, such as the National Fatherhood Initiative and the Promise Keepers."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en40a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Conservative think tanks such as the Heritage Foundation and the Family Research Council have been directly involved in marriage promotion policies. They also are vocal on their views of the negative moral impact that same-sex marriage would have on American society. For these players, a marriage renaissance in American culture is necessary to reestablish the cultural, social, and legal hegemony of heterosexual marriage. They advocate public declarations about the superiority of the two-parent, biological, married family. One example is rewarding those who marry. Senator Sam Brownback (R-KS)—a politician with ties to the religious right and who made a failed run for the Republican nomination for president in 2008—implemented a program in Washington, D.C., to give couples earning under $50,000 a year a marriage bonus of up to $9,000 to buy a house or to pay for job training/education. Such policies seek to influence culture in a pro-marriage direction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Others have focused on the issue of poverty and government efforts to promote marriage among low-income populations. These marriage advocates point to the relationship between single motherhood and poverty as an important reason for public policies to promote marriage. Census data show that children living with married parents have on average a higher family income than children living outside a married family. In 2000, 6 percent of married two-parent families lived in poverty compared to 33 percent of single-mother families."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en41a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Mothers who never marry face conditions of poverty more than any other group, including those who divorce."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en42a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Marriage advocates argue that there is a “marriage gap” dividing America and begetting a rigid caste society: “A self-perpetuating single-mother proletariat on the one hand, and a self-perpetuating, comfortable middle class on the other.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en43a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Several policy analysts from the Center for Law and Social Policy (CLASP), a liberal think tank whose "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("mission is promoting “progressive policies on welfare reform, child support, [and] child care,” have written extensively about marriage promotion and poverty."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en44a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Some assert that if poor women and men married, poverty rates would diminish. Robert Rector and others from the Heritage Foundation conducted a study that simulated the effects of higher marriage rates by using data from the U.S. Census Bureau for the year 2000 by “marrying” single mothers with men of identical demographic characteristics. They found that 80 percent would be “lifted out of poverty.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en45a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" Isabel Sawhill and Adam Thomas of the Brookings Institution simulated marriage rates by restoring marriage to 1970 levels. Using income to measure poverty, they concluded that the 1998 child poverty rate would have been 4.4 percentage points lower than its actual 18.3 percent level. Such simulations, however, do not take into account the social and historical factors affecting poor mothers in the past fifty years."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en46a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" Using retrospective family life history data, the sociologists Lichter, Graefe, and Brown found that there may be a slight economic benefit of marriage for poor women, but, taking into account structural barriers, marriage is no “panacea.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en47a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Scholars who are critical of marriage promotion have raised concerns about government policies that could lead to negative outcomes for women and children. The feminist scholars Stephanie Coontz and Nancy Folbre argue that the current pro-marriage agenda is misguided for at least four reasons. First, nonmarriage often results from poverty and not the other way around. Second, the quality of relationships is important to child outcomes, so encouraging couples to marry might leave these families worse off if there is abuse or divorce. Third, two-parent families in the United States are also susceptible to economic stresses that can have a negative effect on children. Fourth, single parenthood does not necessarily lead to poverty."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en48a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" In countries with a more adequate social safety net, single-parent families are much less likely to be impoverished. One of the greatest concerns for critics of marriage promotion is the issue of domestic violence. Studies show that between 50 and 60 percent of women on welfare have experienced domestic violence, compared to 22 percent of the general population."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en49a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Women and children in poverty are particularly vulnerable to domestic abuse. Critics fear that promoting marriage could compel poor women to stay with an abusive partner. The word “healthy” was added to the national marriage initiative in order to underscore the goal of keeping women safe. However, the commitment of government officials to prioritize combating domestic violence is somewhat questionable. The welfare reform bill of 2006 failed to include proposed guarantees to require qualified domestic-violence experts, and it did not ensure that all marriage promotion programs would be voluntary."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en50a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Another criticism of marriage promotion is its potential to discriminate against the unmarried—especially those who are not allowed legal entry. Jen Heitel Yakush, a senior public policy associate of the Sexuality Information and Education Council (SEICUS), criticizes the federal government for spending billions of dollars to promote heterosexual marriage as a way of “preaching ideology and a narrow definition of morality.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en51a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Early on, marriage advocates staved off a discussion of same-sex marriage by staying silent and downplaying the marriage debate. Not long after, however, a "), _c('em', [_vm._v("USA Today")]), _vm._v(" article spelled out the conundrum: “The key question that the movement’s leaders—and critics—are grappling with is how one can be a proponent of marriage in general but oppose marriages between gays.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en52a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" On this question, David Blankenhorn confesses in the article that marriage promoters are split. On the one hand, a large group unreservedly rallies to ensure marriage remains exclusively heterosexual and, on the other, a very smaller faction believes marriage would benefit lesbians and gay men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While internal disagreements are endemic to movements and organizations that seek social change (in this case to reinstitutionalize marriage), the ultimate goal of marriage promotion has two faces. The first promotes a heterosexual marriage culture that positions same-sex couples as outsiders. The second attempts to strengthen marriage’s boundary by assimilating a group who has challenged its limits: poor single mothers. In this book, I argue that marriage promotion relies on an understanding of marriage that espouses a hierarchical gender and sexual order, and an ideology that demonizes welfare “dependency” as an assault on freedom and responsible citizenship. While marriage advocates espouse a rainbow of political and religious persuasions, all in varying degrees draw on a tradition of Christian morality that has shaped the meaning of marriage in the United States and inspires a nostalgia for a time when marriage was the unquestioned norm for organizing family life. Moreover, marriage advocates predominantly embrace a free-market capitalist ideology that prioritizes the nuclear family unit as an essential component of American identity. The next section discusses the contributions of this research to theories of sexuality studies and inequality.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("Boundary Work and Marital Outsiders")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The historians John D’Emilio and Estelle Freedman document the historical emergence of dominant meanings of sexuality and family life in the United States. Their analysis underscores the ways that sexuality is constructed in relation to the social organization and history of a “system of sexual regulation.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en53a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("Sexuality scholars who theorize the interrelationship of marriage and sexual regulation have brought about a renewed focus on the institution of heterosexuality."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en54a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" The emergence of “critical heterosexuality studies,” originating in radical lesbian feminist critiques of “compulsory heterosexuality” as a patriarchal institution, calls into question taken-for-granted understandings of heterosexuality as coherent and universal, and it investigates its multiplicity of meanings, institutional arrangements, and hierarchies."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en55a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" It further points a critical lens on the ways that heterosexuality serves as the standard for all “sexual-socio behavior.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en56a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" The emergence of queer theory in the 1990s also invigorated critical analyses of heterosexuality, such as the work of Jonathan Katz, who documents the recent invention of the concept of heterosexuality in the past hundred years."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en57a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" Early queer theorists have elucidated the emergence of “the homosexual” as a category of person distinct from “the heterosexual” in the later part of the nineteenth century, and the subsequent amassing of medical, legal, psychological, and literary discourses based on the heterosexual/homosexual binary."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en58a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In her seminal work on the epistemology of the closet, Eve Kosofsky Sedgwick proposes that “many of the major nodes of thought and knowledge in twentieth-century Western culture as a whole are structured—indeed fractured—by the now endemic crisis of homo/heterosexual definition, indicatively male, dating from the end of the nineteenth century.” The closet, which according to Sedgwick characterizes gay oppression in this century, is a structure that is connected to broader configurations of secrecy and disclosure, of the private and the public, with the ability to dislocate the dominant heterosexist culture. It contains a “dangerous incoherence” that requires individuals to negotiate being “in” or “out” in a manner that links to injurious designations of homosexuality."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en59a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" In this book, I argue that marriage ideology draws on these mappings of the closet to prohibit an implicit homosexuality that troubles marriage’s unproblematic hegemony. This ideology organizes knowledge of heterosexuality, citizenship, and national belonging to uphold marriage as the “natural” and universal family formation. In the past two centuries, transformations in intimacy and family life have focused the act of marriage as a private, discreet choice that represents personal commitment and love. This private mapping obscures marriage’s public nature and its regulation of sexuality, gender, and citizenship."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en60a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" Thus, this ideology hides the work of concealing homosexuality’s shadow and presents a simple choice based on consensual, romantic (heterosexual and monogamous) love."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en61a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the cultural theorist Neil Gross argues, there has been a decline in the “regulative tradition” of “lifelong, internally stratified marriage” (LISM) "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("or the cultural context for regulating the heterosexual dyad through state control or a religiously sanctified commitment, based on an unequal division of labor and power between genders."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en62a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" In addition to this regulative tradition are “meaning-constitutive traditions” that shape social action from generation to generation. Thus, while it has become easier for people to enter and exit relationships of their choosing, there still exists an ideal and hegemonic form of coupledom extolled by the regulative tradition of LISM. Meaning-constitutive traditions condition “the thinkability of particular acts and projects.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en63a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" These traditions act as a commonsense way to mark how things have “always” been done. Celine-Marie Pascale examines the ways that commonsense knowledge of race, class, and gender is both “moral and ideological.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en64a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Its moral purpose works to construct boundaries between “us” and “them” through everyday, unconscious practice. On an ideological level, commonsense knowledge is naturalized as participating in a universe of facts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many marriage advocates draw on a universe of facts in order to view marriage in relation to nostalgia for a past when the “traditional” nuclear family and home life were thought to constitute the ideal, and when marriage was not troubled by high rates of divorce, out-of-wedlock childbearing, or what, for some, is the “threat” of same-sex marriage."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en65a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" The historian Stephanie Coontz first wrote about “nostalgia as ideology” in "), _c('em', [_vm._v("The Way We Never Were: American Families and the Nostalgia Trap")]), _vm._v(", arguing that nostalgic ideals of a morally superior family are based on ahistorical assumptions embraced by the right and even the left."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en66a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" The political scientist Mary Caputi further maps out how the conservative movement in the United States is inspired by an image of “home” that offers a common ground in the face of the diversity, fractiousness, and dissonance that have always been central to American identity."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en67a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" In recent decades, this image of home has brought comfort in the face of the massive identity dislocations of the 1960s and 1970s. Speaking of this period, the sociologist Fred Davis argues that Americans experienced perhaps “the most wide-ranging, sustained, and profound assault on native belief concerning the ‘natural’ and ‘proper’ that has ever been visited on a people over so short a span of time.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en68a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" In response, the Reagan Revolution tied together America’s free-market corporate culture, moral/religious traditions, and suburban family life in a zeitgeist to enable Americans “to "), _c('em', [_vm._v("go back")]), _vm._v(" to our former identity, search the past for forgotten meanings, and re-create a former, more innocent version of ourselves.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en69a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marriage ideology draws on the past when marriage was supposedly unburdened by the specters of homophobia, class divisions, and gender "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("and racial politics. Identity-based politics that have emerged alongside the conditions of postindustrialism and globalization represent possibilities and excitement, as well as sweeping angst. As an “escape from freedom,” the heterosexual family has often served as a pillar of steadfastness by promoting an ideology of conservative gender norms."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en70a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" The historian Elaine Tyler May documents how a focus on the “traditional” family during the postwar period of the 1950s offered a response to the threat of international communism residing not only outside national borders but invading America from within, at home. The emphasis on conservative gender norms, patriotism, authority, and hygiene acted as buffers to the panic that American society might unravel from within."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en71a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" McCarthyism sought to rout out internal threats such as “the homosexual.” The 1990s were also anxious times marked by the paranoid beliefs of homespun extremist groups that culminated in events like the Oklahoma City bombing and that continued in post-9/11 America with its fear of terrorism and an increased culture of security. It is in these times that the politics of marriage have become more visible and strident, bringing to the fore the question of the relationships among marriage, heterosexuality, gender, and nostalgia, as Americans face the growing challenges posed by structural changes in global economies, transformation in family life, and movements for lesbian and gay rights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marriage advocates, and even many supporters of same-sex marriage, argue that the case to promote marriage is based on the “polarizing and politically charged assertion that children do best when their parents are married.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en72a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" Such language is rooted in the normative claim that the benefits of marriage guard against the harms of illegitimacy and familial pathology, ideas that draw on a discourse once used to describe the “tangle of pathology” among African American single-mother families. The American and New Jersey Psychological Association’s brief, submitted in the case challenging New Jersey’s ban against same-sex marriage, characterized the discrimination that lesbian and gay families face as a stigma due to illegitimacy: “When same-sex partners cannot marry, their biological children are born ‘out-of-wedlock,’ conferring a status that has historically been stigmatized as ‘illegitimacy’ and ‘bastardy.’”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en73a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" The Indiana appeals court in "), _c('em', [_vm._v("Morrison v. Sandler")]), _vm._v(", in favor of the state’s same-sex marriage ban, found that the state “could legitimately create the institution of opposite-sex marriage, and all the benefits accruing to it, in order to encourage male-female couples to procreate within the legitimacy and stability of a state-sponsored relationship and to discourage unplanned, out-of-wedlock births resulting from ‘casual’ intercourse.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en74a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" The abundance of the discourses of illegitimacy in court cases, the "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("media, and popular culture demonstrates a subtle racialization that speaks to the “normality,” respectability, and security of the white, middle-class, nuclear family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Contemporary rhetoric against illegitimacy employed by commentators and scholars of all stripes reflects dominant cultural repertoires that link to ideas about an era when divorce, out-of-wedlock childbearing, and sex outside marriage were unambiguously stigmatized and resulted in public shunning. Not all marriage advocates agree on whether single-mother and divorced families should again be publicly stigmatized; however, they do argue for the necessity of upholding the public meaning of marriage where society, as the conservative commentator Maggie Gallagher notes, “formalizes its definition, and surrounds it with norms and reinforcements, so we can raise boys and girls who aspire to become the kind of men and women who can make successful marriages.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en75a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" Marriage thus acts as an important apparatus of the state to produce the right kind of citizenry. In her history of marriage in America, Nancy Cott argues that the founders held a political theory of marriage that conceived marital and political governance on a continuum where consent and the Christian ideal of marital union mirrored state authority over citizens who were thought to freely consent to the rule of law."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en76a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the making of the nation, moral and political thinkers reinforced the ideal of “one marriage,” based on the Anglo-American ideal of Christian, heterosexual monogamy, thus venerating it as morally superior to the ongoing practice of polygamy and other complex marriage practices that were predominant among cultures in the global South and among natives of North and South America. The laws of marriage also regulated racial relationships. In slaveholding states before the Civil War, marriage law prohibited slaves from marrying, making it easier to break up families when expedient."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en77a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" White southerners defended slavery, including the rape and molestation of slave women, by pointing to a paternalistic social order in which the white master protected his family, “black and white.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en78a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" From the founding of the nation until the U.S. Supreme Court’s "), _c('em', [_vm._v("Loving v. Virginia")]), _vm._v(" (1967) decision, racially based state laws nullified and criminalized interracial marriage to keep the white race unmixed."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en79a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" The federal government persistently scrutinized the marital lives of any group deemed nonwhite.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To regulate sexuality, the anthropologist Gayle Rubin points to the persistence of a hierarchy of sexual behavior that places marital (reproductive) heterosexuality alone at the top of an erotic pyramid."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en80a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" As a sociologist of sexuality, Jeffrey Weeks points out that morality and sexual behavior have "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("been intimately connected—“to the extent that ‘immorality’ in the English language almost invariably means sexual misbehaviour, and ‘moral’, to a lesser but still potent extent, implies adherence to certain agreed norms of behaviour.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en81a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" Valorizing this hierarchy, U.S. federal and state laws attach a considerable number of benefits to marriage: retirement and death benefits, family leave policies, health-care decision making and access, taxation, immigration, and numerous others. In this way, knowledge about “proper” sexuality is ultimately tied to knowledge about the American family that relies on Christian principles of monogamy, nationalism, and heteronormativity—the view that heterosexuality comprises the standard for sexual and intimate relations. Thus, the power of state practice rests not only on specific law and policy, but also on the ability to conceal the work involved in maintaining the unitary “nature” of institutionalized heterosexuality. In recent years, it has become necessary to visibly reinforce the ideal of “one marriage” through laws like federal and state Defense of Marriage Acts and constitutional amendments to define marriage as exclusively heterosexual (as well as monogamous).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this study of marriage promotion in the United States, I argue that marriage ideology is anchored in (1) a moral “meaning-constitutive tradition” that draws on current conceptions of family values to guard against homosexuality and espouse a hierarchical gender order and (2) an ideology of welfare “dependency” as an assault on freedom and responsible citizenship. Marriage advocates hold different perspectives on politics and religion. Nevertheless, they agree on the importance of marriage in American society to the fabric of the social order. Most also embrace a free-market capitalist ideology that prioritizes the nuclear family unit as an essential component of American identity. This understanding promotes a “bourgeois normality,” in the words of the marriage advocate and author Kay Hymowitz, which organizes key elements of American identity according to the American dream, personal freedom, assimilation, and individual responsibility."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en82a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thus, marriage promotion combines the contradictory threads of “market fundamentalism,” religion, and morality that shape the American view of marriage—Americans must take personal responsibility to beget children within the confines of heterosexual marriage. The sociologist Margaret Somers defines market fundamentalism as the “drive to subject all of social life and the public sphere to market mechanisms.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en83a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" The philosophy of market fundamentalism is amenable to mainstream beliefs of a positive relationship between unfettered markets and individual freedom. Deeply embedded "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("in American culture and social institutions, individualism represents the dominant frame of freedom and prosperity that is fundamental to the American way of life. Bellah and colleagues provide a portrait of the evolution of American individualism to argue that its pervasiveness and ambiguities beget isolation and inequality by proscribing an alternative."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en84a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" Within the American imaginary, it is just commonsense to place responsibility squarely on the individual’s shoulders for determining life’s chances. It is this philosophy that generates the beliefs and cultural repertoires that sustain and perpetuate capitalism. The dominance of individualist language in American society facilitates an easy embrace of the morally rational actor and obscures the visibility of structural constraints (e.g., lack of education, skills, or work experience). Bringing together campaigns of traditional and “neo-family values,” marriage advocates often seek to promote a “strong and free America.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en85a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To examine the ideology and implementation of marriage promotion, I apply a cultural analysis of boundary work that traces how social scientific research is translated into policies and practices that reinforce and produce inequality between middle-class families and the poor. A growing field in cultural sociology has investigated how conceptual distinctions in everyday practice produce, maintain, and contest institutionalized and ongoing social difference."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en86a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" Symbolic boundaries, the conceptual “tool kits” that are a site of struggle and consensus of shared meaning, are essential to the production of social boundaries, the unequal distribution of material and nonmaterial resources and opportunity."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en87a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" Through comparative research, for example, Michèle Lamont elucidates the categories or “mental maps” that people use when drawing moral and symbolic boundaries between “us” and “them.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en88a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" On an interactional level, individuals do cognitive work in their everyday lives that can build and is built on institutional division and difference. “Boundary work,” according to the sociologist Christena Nippert-Eng, constitutes “the strategies, principles, and practices we use to create, maintain, and modify cultural categories.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en89a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blurred lines of intimacy and sexuality that mark a distinction between the “pure” and the “polluted” have spurred boundary work to reframe what counts as a right, such as the right to sexual privacy and to marry."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en90a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" These debates illuminate weighty global questions about the place of sexual outsiders in U.S. society. The sociologist Arlene Stein, for example, studied how individuals in a small Oregon community negotiated boundaries when faced with civic disputes involving lesbian and gay rights. She found that economic shifts and changing social norms fueled anxiety and fear over “the stranger next door”—lesbians and gay men living in their midst who were not as easily "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("identifiable as were other outsiders such as Latinos. For many, the growing presence of strangers, along with economic dislocations that wreaked havoc on the “family wage,” threatened stable heterosexual, nuclear families and their tight-knit community."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en91a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Examining the politics of marriage on the ground, "), _c('em', [_vm._v("One Marriage under God")]), _vm._v(" uncovers the striking social consequences of attempts to redraw a boundary of heterosexual marriage. For example, in the following pages I detail the ways that the marriage initiative in Oklahoma uses state welfare money to fund free workshops for the nonpoor, which represents a redistribution of welfare funds away from poor single mothers (see "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3")]), _vm._v("). I investigate the boundary work that seeks to encourage one group—poor single mothers—to marry while endeavoring to exclude another group—gay men and lesbians—from the ability to marry. The conceptual frame of family values based on Christian morality and free-market capitalism, with its philosophy of personal responsibility and choice, motivates this boundary work that upholds marriage as essential to American identity. Theoretically, an examination of the politics of marriage extends social scientific and cultural investigations of how boundaries and identities produce inequality based on race, class, gender, and sexuality in everyday life and institutionally. Marriage advocates, for varied and sometimes disparate reasons, work to uphold the heterosexual, married family as the prototype of “the family,” and a good amount of public policy and funding is being geared in that direction. As marriage promotion takes on more prominence as a potential solution to poverty, it becomes crucial to understand what this policy shift means for poor Americans, who are overrepresented by communities of color and women. It is also critical to consider the consequences of these politics on the lives of those who are legally barred from a seat at the marriage table.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("Ethnographic Tales from Oklahoma")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Initially, my plan to study the politics of marriage had not focused on Oklahoma. Even though the initiative in Oklahoma was a prototype of the national marriage movement, I had set my sights on Arizona, a state much closer to California that had allocated $1 million in federal welfare funds to pilot a marriage education program. I conducted preliminary research in Phoenix at a marriage conference sponsored by the National Association of Marriage Enhancement (NAME), which on the last day unveiled the “marriage mobile,” a project that was to be funded with federal welfare dollars to turn semi-trailer trucks into mobile marriage education classrooms to take "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("to low-income areas in Arizona. A month before I was ready to leave, I called NAME to ask about the next scheduled trip and learned that they had not received federal funding due to Congress’s failure to reauthorize the welfare reform budget. The marriage mobile, which had only taken one trip, was not scheduled to take another any time soon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reconsidering, I changed course to do research in Oklahoma, a state whose marriage initiative had solid funding and had been operating for over four years by the beginning of 2004. During my preliminary research, I had met with two marriage initiative employees from Oklahoma at the Smart Marriages conference, and they had expressed enthusiasm for my project. My change of plan proved fortuitous as Oklahoma has become a national leader in its statewide initiative to promote marriage, and its unique confluence of political conservatism, lagging economics, and entrenched poverty set the stage. For the first few years after the passage of welfare reform in 1996, the focus on marriage promotion had little impact. Most states focused their attention on the work-related provisions of the law to reduce the welfare rolls. In 2000, Wade Horn, then the president of the National Father-hood Initiative, wrote in his weekly column about “Fatherly Advice” that he had been traveling around the country for four years trying to convince state officials to spend some of their welfare dollars on activities to promote marriage. He lamented: “Everywhere I went, my exhortations resulted either in disbelief that welfare funds could be spent for such a purpose or with scornful dismissals that marriage is none of government’s business.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en92a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This lack of attention to marriage promotion changed on March 25, 2000, when in a “bold move,” declared Horn, the governor of Oklahoma announced that he would designate $10 million of the state’s TANF Federal Block Grant for the purpose of promoting marriage. Horn anticipated that the “flood-gates for spending” on programs were opening, and Oklahoma was on the front line. The state has been one of the most visible trendsetters of the marriage movement, evidenced by titles to workshops at the Smart Marriages conference like “Oklahoma: Leading the Way.” Oklahoma does not represent the diverse marriage promotion programs that have peppered the country in the last decade, which are often small and community based. The approach and strategy in Oklahoma, however, have been significant inspiration for the creation of programs, especially for statewide initiatives. I met representatives visiting from Florida who were looking to start a statewide initiative at one of the training workshops I attended. The Texas Healthy Marriage and Relationship Initiative, which in 2007 began to allocate 1 percent of the state’s total TANF Federal Block Grant each year to healthy marriage activities, has "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("a similar model to that of Oklahoma. In recent years, a series of research briefs for HHS/ACF has used Oklahoma as the longest-running marriage initiative in the nation to offer examples to other states and programs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Embracing the adventure, I packed my truck with clothes, books, and equipment for my research, and I drove twenty hours in February 2004 to Oklahoma, which became my home for the next ten months. Once there, I was able to contact one of the women I’d met at the Smart Marriages conference, and I began to do participant observation of the marriage workshops right away and, over time, I conducted twenty in-depth interviews with participants (see Appendixes A and B for more details about the entire sample and methods). Workshops for the general public were free of charge, and engaged couples who attended the program together qualified for a $45 discount on their $50 Oklahoma marriage license. The workshops included large Sweethearts Weekends that occurred every few months and offered marriage education on a Friday evening and all day Saturday. Advertised on local radio stations and in the newspaper, each Sweethearts Weekends workshop had fifty or more couples on average. Weekly smaller workshops were advertised on the initiative’s website and through local churches."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en93a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to the workshops for the general population, the statewide marriage initiative also targeted specific populations, and, after my initial field-work on workshops for the general public, I began to branch out to study these other programs. In April, one of the marriage initiative employees informed me about marriage education workshops that were being taught to welfare clients (not advertised on the website for the general public) and asked if I would like to observe these. I prioritized attending these for the next three months to study the population that is central to the debates over the antipoverty focus of marriage promotion. These workshops met twice a week, were built into the client’s first week of orientation, and each comprised five to twenty-five participants—predominantly single mothers. One married couple and two single men participated during the weeks I attended. In addition, I attended an entire weeklong orientation (Monday through Friday) to assess what other materials and classes were offered. During lunch, I often remained onsite to talk with clients while we ate. Other times, I would go out for lunch with the workshop leaders when invited. I also attended a six-week marriage workshop that met twice a week and was held during a class for TANF participants to get their high school equivalency diploma (GED). All of these classes were mandatory in the sense that they were offered either as part of the required orientation or as part of the GED curriculum (see "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 4")]), _vm._v("). Toward the end of my field-work, I conducted three focus groups with volunteer participants during their "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("lunch breaks, with each session lasting one hour. I brought in sandwiches or pizza for the clients to eat and told that them that participating was completely voluntary, an opportunity to chat about their experiences in the relationship class."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en94a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" I also interviewed four of the workshop leaders and the supervisor of the TANF office.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another marriage initiative activity that I prioritized were marriage education lessons taught through family and consumer science classes at high schools. Again, I viewed these classes as especially important to study because teenage pregnancy has been central to debates about poverty, marriage, and single motherhood."), _c('sup', [_c('a', {
    attrs: {
      "id": "int_en95a"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10_notes#int_en95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" I attended daily classes at two high schools: one in a largely white, suburban area for a month and the other in an urban high school with a predominantly African American and Latino population for almost two months. These classes incorporated into their program a curriculum designed by the marriage initiative that included a workbook for each student. The initiative provided the teacher training and workbooks. In these classes, I assisted as a sort of “teacher’s aide” and was thus slotted into the role of an authority figure. However, I would sit with the students as they did their exercises, and they sometimes would share things that “the teacher wouldn’t agree with,” such as their feeling that cohabitation before marriage is okay. At the end of my fieldwork at each school, I interviewed the teachers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The marriage initiative also provided services to the Chickasaw Nation and the prison population. I was able to attend a workshop with a curriculum that had been especially designed for employees of the Chickasaw Nation. Attendance earned extra points toward the employee’s year-end monetary bonus, and in that year about fifty had attended the one-day workshop. Fifteen were present at the workshop I participated in. Afterward, I interviewed the director who had designed the curriculum and supervised the workshops. I was able to interview a prisoner and his wife who had participated in a marriage workshop in prison as well as the chaplain who taught the course (see Appendix A for discussion of the problems accessing this population).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, during my stay in Oklahoma, I conducted fieldwork on the campaign to ban same-sex marriage. I attended rallies, news conferences, and fundraising events in favor of and against the ban. I attended the church of one of the pastors who was leading the campaign against same-sex marriage and alternatively an “accepting” church of lesbian and gay parishioners. Over time, I conducted interviews with two leaders of the campaign against same-sex marriage and five leaders who fought the ban. Both of the leaders of the ban against same-sex marriage were also leaders of the marriage initiative, and I asked to interview them in connection with this program and then also "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("asked questions about the ban against same-sex marriage. I sat in on meetings with several gay and lesbian organizations that were fighting the ban, and I interviewed an organizer from a national lesbian and gay organization who had come to Oklahoma from New York to help fight against the ban.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My last two months in Oklahoma proved to be especially disheartening after the constitutional amendment to ban same-sex marriage passed with 76 percent of voters in favor. During the many months I spent in Oklahoma, I experienced firsthand the suffering, mental anguish, and material hardships that lesbians and gay men endured due to lack of legal protections of their basic civil and human rights. One particularly tragic story, chronicled in the documentary film "), _c('em', [_vm._v("Tying the Knot")]), _vm._v(", was that of Sam Beaumont, whom I interviewed during his five-year legal battle to save his ranch in Bristow, Oklahoma, where he and his partner, Earl Meadows, had lived for twenty-four years. When Earl died in 2000, long-lost cousins appeared out of nowhere to legally evict Sam, despite Earl’s notarized will that left Sam the estate but mistakenly recorded only one witness signature rather than the required two. In a travesty of justice, Oklahoma courts bestowed the estate to the distant cousins. It is my goal in this book to uncover the boundary work that supports such discriminatory institutional and everyday practice.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("Overview of the Book")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Traveling throughout Oklahoma to study its marriage initiative, I discovered a number of important revelations that I map out in the following pages. "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" sets the stage in presenting the ideological connections between campaigns against same-sex marriage and marriage promotion initiatives. These two phenomena connect in their shared perception of marriage as the “building block” of the nation and as an essential component of American identity. "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 2")]), _vm._v(" and "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" examine the ways that the ideology of marriage promotion forms the basic strategies and determines the dissemination of services on the ground. "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" investigates in depth the boundary work of marriage promotion workshops offered to the general population, which rehearses ideas concerning hierarchical gender relations. By teaching about the “opposite sexes,” these workshops organize knowledge that depends on homosexuality’s omission, a boundary troubled by the presence of a lesbian couple in two workshops. "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" uncovers the marriage initiative’s strategies to preserve a boundary of heterosexual marriage through practices that, in contrast to the stated goal of closing the marriage gap, paradoxically do more to sustain or widen it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 4")]), _vm._v(", "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(", and "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" focus on the boundary work of marriage promotion among targeted populations. "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" focuses on the small number of marriage workshops directed both at poor single mothers in conjunction with receiving TANF benefits and at the prison population. My research reveals how marriage promotion reinforces the outsider status of poor single women, and also the strategies that both social workers and TANF clients use to resist this ideology that has little relevance to poor women’s lives. "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(" examines classes that used the state-sponsored marriage initiative curriculum to teach the “essentials” of marriage to students at two high schools, and "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 6")]), _vm._v(" looks at the marital politics among Native Americans as an example of the importance of race and culture to understanding marriage ideology.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Overall, the politics of marriage in Oklahoma provided an unprecedented opportunity to study the hopes and fears of a broad range of Americans concerning the symbol of marriage within the context of transforming gender, sexual, and family relations, of ideas about welfare, race, and inequality, and of shifting moral and religious beliefs in American society. This book tells the story of a particular time and place that reflects broad trends, including an entrenchment of market fundamentalist ideals with a focus on cultural solutions to social problems, a political shift to the right propelled by conservative Christian leaders, and the political divisiveness of marriage politics. Marriage promotion politics in Oklahoma represents the perfect entry to study the social consequences of these significant shifts in American culture.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-303143a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm09_int.vue
// module id = 84
// module chunks = 0